<template>
  <v-row class="my-1">
    <v-col class="py-0">
      <v-textarea
        style="width: 100%"
        v-bind="{ ...$attrs }"
        @input="v => handleUpdate({ value: v })"
        :value="pValue"
        :label="lgLabel"
        :disabled="formDisabled"
        auto-grow
        dense
        outlined
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TextArea",
  props: {
    formDisabled: { type: Boolean },
    label: { type: String, default: "" },
    typename: { type: String },
    values: {
      type: Array,
      default: () => {
        return [{ value: "" }]
      }
    }
  },
  computed: {
    // lgLabel() {
    //   return `${this.label} - ${this.typename}`.toUpperCase()
    // },
    lgLabel() {
      return `${this.label}`.toUpperCase()
    },
    pValue: {
      get() {
        return this.values[0].value
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    handleUpdate(updateObj) {
      const oldObj = { id: 0, value: this.value }
      const newValue = [{ ...oldObj, ...updateObj }]
      this.$emit("input", newValue)
    }
  }
}
</script>
